import ParallaxBehaviour from '../../../helpers/parallax-behaviour';
import { StaticInterface } from '../../../helpers/static-interface';

export interface ITpxSquareUtils {
  applyParallaxBehaviour(percentage: number): ParallaxBehaviour;
}

export interface IStaticTpxSquareUtils {
  new (...args: any[]): ITpxSquareUtils;
  init(scope?: HTMLElement): void;
}

/**
 * Square utilities
 * @class
 */
 export default class TpxSquareUtils implements StaticInterface<IStaticTpxSquareUtils, typeof TpxSquareUtils> {
  #element: HTMLElement;

  /**
   * @constructor
   */
  constructor(element: HTMLElement) {
    this.#element = element;

    if (this.#element.dataset.parallax) {
      this.applyParallaxBehaviour(parseInt(this.#element.dataset.parallax));
    }
  }

  applyParallaxBehaviour(percentage: number): ParallaxBehaviour {
    return new ParallaxBehaviour(this.#element, percentage);
  }

  /**
   * Initiate the square and add any parallax behaviour if necessary
   */
  static init(scope?: HTMLElement) {
    [...(scope || document).querySelectorAll('.a-square[data-parallax]')].forEach(square => {
      new TpxSquareUtils(square as HTMLElement);
    });
  }
}